import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Colors, FontWeight } from '../../../../assets/styles';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingLeft: '35px',
    marginTop:'20px',
    paddingBottom:'20px'
  },
  tableContainer: {
    display: 'flex',
    height: '100%',
    width: '100%',
    pageBreakBefore: 'always',
    '&.MuiPaper-outlined': {
      border: 'none',
    },
  },
  table: {
    marginTop: 20,
    fontSize: '12px',
    height: '100%',
    width: '100%',
    display: 'table',
    border: `1px solid ${Colors.Gray1}`,
  },
  columnTitle: {
    color: Colors.Gray,
    fontWeight: FontWeight.Light,
    fontSize: 14,
    textAlign: 'center',
  },
  contentTitle: {
    color: 'black',
    fontSize: '18px',
    fontWeight: 700,
  },
  sectionTitle: {
    color: 'black',
    fontSize: '16px',
    fontWeight: 700,
  },
  subsectionTitle: {
    color: 'black',
    fontWeight: 300,
    fontSize: 16,
    margin: '5px',
  },
  sectionAmount: {
    width: '25%',
    color: Colors.Gray4,
    fontSize: 14,
    textAlign: 'center',
  },
  subsectionAmount: {
    width: '25%',
    color: Colors.Gray4,
    fontSize: 14,
    textAlign: 'center',
    backgroundColor: 'rgba(204,204,204,0.1)',
  },
  descriptionCol: {
    width: '70%',
    padding: '12px !important',
  },
  descriptionText: {
    margin: 0,
    fontSize: '14px',
    color: 'black',
    lineHeight: '25px',
    padding: '7px 0px',
  },
  noteText: {
    margin: '4px 8px',
    padding: '2px 4px',
    borderLeft: '1px solid #999898',
    marginLeft: '8px',
    borderTop: '1px solid #9998982e',
  },
  valuesCol: {
    padding: '0px',
    '& div:last-of-type': {
      border: `1px solid ${Colors.Gray1}`,
    },
  },
  valueCell: {
    display: 'flex',
    textAlign: 'center',
    borderLeft: `1px solid ${Colors.Gray1}`,
    border: 'none',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    color: 'black',
    fontWeight: 300,
    fontSize: 16,
    '& div:last-of-type': {
      border: `none`,
    },
  },
  full: {
    width: '100%',
    height: '100%',
  },
  half: {
    width: '50%',
    height: '100%',
  },
  third: {
    width: '100%',
    height: '100%',
    fontWeight: FontWeight.Bold,
    color: 'black',
  },
  smallText: {
    fontSize: 10,
    fontWeight: FontWeight.Light,
  },
  composedCell: {
    padding: 0,
    margin: 0,
    height: '100%',
  },
  multiCont: {
    display: 'flex',
    height: '100%',
    '& div:last-of-type': {
      borderLeft: `1px solid ${Colors.Gray1}`,
    },
  },
  infoBlock: {
    border: '1px solid #666',
    padding: '15px',
    marginBottom: '25px',
    fontSize: 'calc(100% - 2px)',
    fontWeight: 300,
    '& strong': {
      fontWeight: 700,
    },
  },
  footnoteBlock: {
    border: '1px solid #666',
    padding: '15px',
    marginBottom: '15px',
    marginTop: '15px',
    fontSize: 'calc(100% - 2px)',
    fontWeight: 300,
    '& strong': {
      fontWeight: 700,
    },
  },
  specialBlock: {
    width: '100%',
    '& br': {
      marginBottom: '10px',
    },
  },
}));

export default useStyles;